<template>
  <page-overlay class="modal-root" :isOpen="!!currentComponent" :popup-alignment="popupAlignment">
    <component :is="currentComponent" v-on:close="handleClose" v-bind="props" />
  </page-overlay>
</template>

<script>
import PageOverlay from '../base-components/PageOverlay.vue';
import ModalBus from '../event-bus/modal-bus';
import Intercom from '../Intercom';

export default {
  name: 'ModalRoot',
  components: {
    PageOverlay,
  },
  data() {
    return {
      currentComponent: null,
      props: null,
      popupAlignment: null,
    };
  },
  created() {
    ModalBus.$on('open', ({ component, props = null, popupAlignment = null }) => {
      document.body.classList.add('modal-open');
      Intercom.hideLauncher();
      Intercom.hide();
      this.currentComponent = component;
      this.props = props;
      this.popupAlignment = popupAlignment;
    });
    document.addEventListener('keyup', this.handleKeyup);
    ModalBus.$on('close-modal', () => {
      document.body.classList.remove('modal-open');
      this.currentComponent = null;
      this.props = null;
      this.popupAlignment = null;
    });
    document.addEventListener('keyup', this.handleKeyup);
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.handleKeyup);
  },
  methods: {
    handleClose() {
      document.body.classList.remove('modal-open');
      Intercom.showLauncher();
      this.currentComponent = null;
      this.props = null;
      this.popupAlignment = null;
    },
    handleKeyup(e) {
      if (e.keyCode === 27) {
        this.handleClose();
      }
    },
  },
};

</script>

<style lang="scss" scoped>
  .modal-root {
    z-index: 20;
  }

</style>



// WEBPACK FOOTER //
// src/modal/ModalRoot.vue